import * as React from 'react'

import { Label, SubText, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { UserLabelStyled } from './styles/UserLabelStyled'
import { type Department, type PayCardholder, type User } from '../../models'
import { getFullName } from '../../utils/user'
import { UserAvatar } from '../UserAvatar'
import { type IWithUserTooltipProps, WithUserTooltip } from '../WithUserTooltip'

export interface IUserLabelProps {
  user: Partial<User> & Pick<User, 'firstName' | 'lastName'>
  WithUserTooltipProps?: Partial<IWithUserTooltipProps>
  showDelegatee?: boolean
}

export const cardHolderToUser = (
  cardholder: PayCardholder & {
    department: Department
  }
): Partial<User> => {
  return {
    id: cardholder.id,
    firstName: cardholder.first_name,
    lastName: cardholder.last_name,
    profile_image: cardholder.profile_image,
    department: cardholder.department,
  }
}

export const UserLabel = ({
  user,
  WithUserTooltipProps,
  showDelegatee = false,
}: IUserLabelProps) => {
  const intl = useProcurifyIntl()

  return user ? (
    <WithUserTooltip {...WithUserTooltipProps} user={user}>
      <UserLabelStyled>
        <Label
          component={
            <UserAvatar
              shadow={false}
              url={user.profile_image}
              size='xsmall'
              circular
            />
          }
        >
          <Text bold={false} autoMargin={false}>
            {getFullName(user)}
          </Text>
          {showDelegatee && user.approval_delegatee && (
            <SubText bold={false} autoMargin={false} color='textSecondary'>
              {intl.formatMessage(messages.delegatedToLabel, {
                delegateeFullName: getFullName(user.approval_delegatee),
              })}
            </SubText>
          )}
        </Label>
      </UserLabelStyled>
    </WithUserTooltip>
  ) : null
}
